import LXCenter from '../core/components/center';
import SuccessForm from './components/successForm';

const SuccessPage: React.FC = () => {
  return (
    <LXCenter>
      <SuccessForm></SuccessForm>
    </LXCenter>
  );
};

export default SuccessPage;
